import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const GRADIENTS = [
  "linear-gradient(135deg, hsl(var(--cc-terracotta)) 0%, hsl(var(--cc-clay)) 100%)",
  "linear-gradient(135deg, hsl(var(--cc-forest)) 0%, hsl(88 40% 38%) 100%)",
  "linear-gradient(135deg, hsl(var(--cc-gold)) 0%, hsl(var(--cc-clay)) 100%)",
  "linear-gradient(135deg, hsl(16 75% 63%) 0%, hsl(var(--cc-terracotta)) 100%)",
  "linear-gradient(135deg, hsl(var(--cc-charcoal)) 0%, hsl(var(--cc-clay)) 100%)",
];

export const initials = (name?: string | null) =>
  (name || "?")
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

const gradientFromId = (id?: string | null) => {
  if (!id) return GRADIENTS[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length];
};

export function GradientAvatar({
  name,
  src,
  id,
  size = 40,
  className,
  ring,
}: {
  name?: string | null;
  src?: string | null;
  id?: string | null;
  size?: number;
  className?: string;
  ring?: boolean;
}) {
  const gradient = gradientFromId(id || name);
  return (
    <Avatar
      className={cn(ring && "ring-2 ring-white shadow-md", className)}
      style={{ width: size, height: size }}
    >
      {src && <AvatarImage src={src} alt={name || ""} />}
      <AvatarFallback
        style={{ background: gradient, color: "white", fontWeight: 700, fontSize: size * 0.36 }}
      >
        {initials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
